/**
 * @generated SignedSource<<9fb7ee9525bd31bfa66918a60651e196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "LegalContract",
  "kind": "LinkedField",
  "name": "legalContract",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FacilitiesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "allFacilities",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContractFragments_AllContractsDropdown"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FacilitiesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "allFacilities",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityIdentifier",
            "kind": "LinkedField",
            "name": "identifiers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityVersion",
            "kind": "LinkedField",
            "name": "applicableVersion",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalContract",
        "kind": "LinkedField",
        "name": "allLegalContracts",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e89d0f1afff83730913260e60b18b07",
    "id": null,
    "metadata": {},
    "name": "FacilitiesQuery",
    "operationKind": "query",
    "text": "query FacilitiesQuery {\n  allFacilities {\n    id\n    legalContract {\n      id\n      name\n    }\n    identifiers {\n      identifierType {\n        code\n        id\n      }\n      value\n      id\n    }\n    applicableVersion {\n      displayName\n      id\n    }\n  }\n  allLegalContracts {\n    ...ContractFragments_AllContractsDropdown\n    id\n  }\n}\n\nfragment ContractFragments_AllContractsDropdown on LegalContract {\n  id\n  name\n}\n"
  }
};
})();

node.hash = "7e9dac27811eee69a8cf932719e0f978";

export default node;
